/* ComponentAutocomplete template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PlaceholderIcons } from '@cewe-designsystem/util_placeholder_icons';
import { AutocompleteComponent } from './cwc-autocomplete';

/**
 * Definition of  parameters that the template needs to work.
 */
interface AutocompleteTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: AutocompleteComponent;

  // Specify parameters that are required to be passed down to the template here.
}

const AutocompleteTemplate: FunctionalComponent<AutocompleteTemplateProps> = ({ controller }) => (
  <Host>
    <cwc-component-autocomplete-input>
      <slot name={'icon'}></slot>
      <input
        type="text"
        name={controller.name}
        placeholder={controller.placeholder}
        value={controller._initialValue}
        onInput={() => controller.onInputfieldInput()}
        onBlur={() => controller.onBlurInput()}
        onKeyDown={(e: KeyboardEvent) => controller.onInputKeyDown(e)}
        disabled={controller.disabled}
        autocomplete="off"
      />
      <icon class="reset" name="close" onClick={() => controller.onReset()}>
        <slot name={'reset-icon'}>
          <svg viewBox={'0 0 24 24'}>{PlaceholderIcons.close()}</svg>
        </slot>
      </icon>
    </cwc-component-autocomplete-input>

    <cwc-component-autocomplete-suggestions style={!controller.open ? { display: 'none' } : {}}>
      {controller._searchResults.map((v, k) => {
        return (
          <cwc-component-autocomplete-suggestions-item
            class={k === 0 ? 'selected' : ''}
            onClick={(e: MouseEvent) => controller.onSearchItemClicked(e)}
          >
            {v[controller.dataKey]}
          </cwc-component-autocomplete-suggestions-item>
        );
      })}
    </cwc-component-autocomplete-suggestions>
  </Host>
);

export default AutocompleteTemplate;
